import { getFeature } from 'Cloud/Application/FeaturesEs6';
import { IS_BIZ_USER, IS_MOBILE_BROWSER, IS_PAID_USER, IS_WEBVIEW } from 'reactApp/appHelpers/configHelpers';

type TariffIds = {
    month: string;
    year: string;
};

const expensivePlanTrial: 'a' | 'b' | 'c' = getFeature('expensive-plan-trial') || 'a';

export const expensivePlanTrialA: boolean = expensivePlanTrial === 'a';
export const expensivePlanTrialB: boolean = expensivePlanTrial === 'b';
export const expensivePlanTrialC: boolean = expensivePlanTrial === 'c';

export const enabledExpensivePlanTrial =
    !IS_BIZ_USER && !IS_MOBILE_BROWSER && !IS_WEBVIEW && !IS_PAID_USER && (expensivePlanTrialB || expensivePlanTrialC);

export const expensivePlanTariffIds: TariffIds = getFeature('expensive-plan-tariff-ids') || { month: '', year: '' };
